import {
    Configuration,
    ProjectControllerApi,
    TranslatableControllerApi,
    TranslationControllerApi,
    BillingApi,
    TranslationJobControllerApi,
    UserManagementApi,
    APIKeyManagementApi
} from "../api";
import apiAxios from "./apiClient";

const apiConfig = new Configuration({
    basePath: process.env.REACT_APP_API_URL || "http://localhost:8080",
});

export const translatableApi = new TranslatableControllerApi(apiConfig, undefined, apiAxios);
export const translationApi = new TranslationControllerApi(apiConfig, undefined, apiAxios);
export const projectApi = new ProjectControllerApi(apiConfig, undefined, apiAxios);
export const billingApi = new BillingApi(apiConfig, undefined, apiAxios);
export const translationJobApi = new TranslationJobControllerApi(apiConfig, undefined, apiAxios);
export const userManagementApi = new UserManagementApi(apiConfig, undefined, apiAxios);
export const apiKeyManagementApi = new APIKeyManagementApi(apiConfig, undefined, apiAxios);
